import React, {Component} from 'react';
import PropTypes from "prop-types";
import ReactVideoModal from "../ReactVideoModal/ReactVideoModal";

class ReactVideoModalStandaloneButton extends Component {

    static propTypes = {
        uri: PropTypes.string.isRequired,
        text: PropTypes.string
    };

    static defaultProps = {
        text: 'Watch Video'
    }

    state = {
        modalOpen: false
    };

    render() {
        return (
            <React.Fragment>
                <ReactVideoModal uri={this.props.uri}
                                 inline={false}
                                 isOpen={this.state.modalOpen}
                                 onClose={() => this.setState({modalOpen: false})}
                />
                <button className="videoButton anchorStyleVideoButton" onClick={() => this.setState({modalOpen: true})}>
                    {this.props.text}
                </button>
            </React.Fragment>
        );
    }
}

export default ReactVideoModalStandaloneButton;



// WEBPACK FOOTER //
// ./frontend/components/ReactVideoModalStandaloneButton/ReactVideoModalStandaloneButton.jsx